import React from "react";
import s from './Modal.module.css';
import cross from './assets/cross.svg';
import PropTypes from "prop-types";
export function Modal(_a) {
    var children = _a.children, close = _a.close, passRef = _a.passRef;
    return (React.createElement("div", { className: s.modal, ref: passRef },
        children,
        React.createElement("button", { className: s.close, onClick: close },
            React.createElement("img", { src: cross, width: "24", height: "24", alt: "close" }))));
}
Modal.propTypes = {
    children: PropTypes.node,
    close: PropTypes.func,
    passRef: PropTypes.any,
};
//# sourceMappingURL=Modal.js.map